import { ALL_SESSION_FILTER, MAX_POLICY_SELECTION, type SessionScope } from "./policySelection";

export const memberSearchParamKey = "member";
export const experimentSearchParamKey = "experiment";
const policySearchParamKey = "policy";

export type PolicyFilterParams = {
  memberUuid: string;
  experimentId: string;
};

export type PolicyCatalogFilters = {
  memberUuid?: string;
  experimentId?: string;
};

// URL은 외부 입력이다. 키가 없으면 두 축 모두 전체 선택으로 읽는다.
export function readPolicyFilterParams(params: URLSearchParams): PolicyFilterParams {
  return {
    memberUuid: params.get(memberSearchParamKey) ?? ALL_SESSION_FILTER,
    experimentId: params.get(experimentSearchParamKey) ?? ALL_SESSION_FILTER,
  };
}

// Team 스코프만 member 축을 서버 질의에 포함한다. experiment는 두 스코프에서 독립적으로 적용한다.
export function readCatalogFilters(
  params: URLSearchParams,
  scope: SessionScope,
): PolicyCatalogFilters {
  const { memberUuid, experimentId } = readPolicyFilterParams(params);
  return {
    ...(scope === "team" && memberUuid !== ALL_SESSION_FILTER ? { memberUuid } : {}),
    ...(experimentId === ALL_SESSION_FILTER ? {} : { experimentId }),
  };
}

// 반복 키(?key=<id>&key=<id>)를 공백·중복 제거 후 선택 상한으로 정규화한다.
export function readPolicyIdsParam(params: URLSearchParams, key: string): string[] {
  const ids = params
    .getAll(key)
    .map((id) => id.trim())
    .filter((id) => id !== "");
  return [...new Set(ids)].slice(0, MAX_POLICY_SELECTION);
}

// id 목록 전체를 다시 쓴다. 빈 목록이면 키를 제거한다. 입력 params는 변경하지 않는다.
export function writePolicyIdsParam(
  params: URLSearchParams,
  key: string,
  ids: readonly string[],
): URLSearchParams {
  const next = new URLSearchParams(params);
  next.delete(key);
  for (const id of ids) {
    next.append(key, id);
  }
  return next;
}

export function readPolicySelectionIds(params: URLSearchParams): string[] {
  return readPolicyIdsParam(params, policySearchParamKey);
}

export function writePolicySelectionParam(
  params: URLSearchParams,
  policyIds: readonly string[],
): URLSearchParams {
  return writePolicyIdsParam(params, policySearchParamKey, policyIds);
}

export function clearPolicySelectionParam(params: URLSearchParams): URLSearchParams {
  const next = new URLSearchParams(params);
  next.delete(policySearchParamKey);
  return next;
}
